<template>
  <transition name="slideout">
    <div
      v-if="slideoutOpen"
      class="product-slideout-wrapper"
    >
      <div
        class="slideout-overlay"
        data-close
        @click="closeSlideout($event)"
      />
      <div class="bundle-customiser-slideout product-slideout">
        <div class="product-slideout__header flex items-center justify-between">
          <h2 class="h5">
            {{ dropdownTitle }}
          </h2>

          <button
            class="close-btn xs font-semibold flex items-center"
            data-close
            @click="closeSlideout($event)"
          >
            Close
            <CloseIcon />
          </button>
        </div>

        <div
          v-if="hasMultipleSelections"
          class="product-slideout__grid grid grid-cols-2 overflow-auto"
        >
          <div
            v-for="(product, index) in collection.products"
            :key="`${collection.label}-${product.variants[0].id}`"
            :disabled="!product.available"
            class="product-slideout-qty-item"
            :class="{ 'product-slideout-qty-item--active': !!collection.selectedProducts.find(selectedProduct => selectedProduct.variants[0].id === product.variants[0].id ) }"
          >
            <div class="product-slideout-qty-item__image">
              <img
                v-lazy="product.smallSachetImage ?? product.images[0]"
                :alt="`${product.title}-image`"
                width="52"
                height="69"
              >
            </div>
            <div class="product-slideout-qty-item__content">
              <h3 class="product-slideout-qty-item__title">
                {{ product.title }}
              </h3>
              <div class="product-slideout-qty-item__quantity quantity-buttons">
                <button
                  class="quantity-buttons__button"
                  @click="decreaseQuantity(product.variants[0].id)"
                >
                  <MinusCircleFilled />
                </button>
                <span class="quantity-buttons__amount">
                  {{
                    selectedProductsArray.find(selectedProduct => selectedProduct.variantId === product.variants[0].id) ? selectedProductsArray.find(selectedProduct => selectedProduct.variantId === product.variants[0].id).quantity : 0
                  }}
                </span>
                <button
                  class="quantity-buttons__button"
                  :disabled="maximumProductsReached"
                  @click="increaseQuantity(index)"
                >
                  <PlusCircleFilled />
                </button>
              </div>
            </div>

            <button
              class="product-slideout-qty-item__action-info-cta"
              @click="showSachetPopup(index)"
            >
              <!-- <iconInfo /> -->
            </button>
          </div>
        </div>

        <div
          v-else
          class="product-slideout__grid grid grid-cols-3 overflow-auto text-center"
        >
          <button
            v-for="(product, index) in collection.products"
            :key="`${collection.handle}-${product.variants[0].id}`"
            :disabled="!product.available"
            class="product-slideout__grid-item"
            :class="{ 'product-slideout__grid-item--active': isActiveProduct(product.variants[0].id) }"
            @click="selectProduct(index)"
          >
            <div
              class="product-slideout__grid-item-image"
              :class="{ 'product-slideout__grid-item-image--png': product.images.includes('.png') }"
            >
              <img
                v-lazy="product.gridImage"
                :alt="product.title"
              >
            </div>
            <h3 class="xs">
              {{ product.title }}
              <span
                v-if="collectionPriceVaries && returnItemPrice(product, 'difference')"
                class="whitespace-nowrap"
              >
                {{ returnItemPrice(product) }}
              </span>
            </h3>
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import {mapState, mapActions} from 'pinia'
import {useBundleStore} from '../pinia/BundleStore'

import CloseIcon from '../icons/close-icon'
import PlusCircleFilled from '../icons/plus-circle-filled'
import MinusCircleFilled from '../icons/minus-circle-filled'

import {productPrice} from '../helpers/product'

export default {
  components: {
    CloseIcon,
    PlusCircleFilled,
    MinusCircleFilled
  },
  computed: {
    ...mapState(useBundleStore, [
      'bundle',
      'bundleOptions',
      'isCollectionBundle',
      'slideoutOpen',
      'activeCollectionIndex',
      'selectedProducts'
    ]),
    collection() {
      return !this.isCollectionBundle ? this.bundleOptions[0] : this.bundleOptions[this.activeCollectionIndex]
    },
    hasMultipleSelections() {
      return this.isCollectionBundle && this.bundleOptions.length > 1
    },
    selectedProductsArray() {
      return this.selectedProducts[this.activeCollectionIndex]
    },
    maximumProductsReached() {
      return this.collection.selectedProducts.length === this.collection.maximumQuantity
    },
    dropdownTitle() {
      return this.collection.label.replace('[INDEX]', this.activeCollectionIndex + 1).replace('1', '1st').replace('2', '2nd').replace('3', '3rd')
    },
    collectionPriceVaries() {
      const firstProductPrice = this.collection.products[0].price
      let variedPrice = false
      this.collection.products.forEach(product => {
        if (product.price !== firstProductPrice) {
          variedPrice = true
          return
        }
      })
      return variedPrice
    }
  },
  methods: {
    ...mapActions(useBundleStore, [
      'closeSlideout',
      'changeProduct',
      'removeProductFromSelections',
      'addProductToSelections'
    ]),
    selectProduct(index) {
      if (this.collection.products[index].available) {
        this.changeProduct(index)
      }
      this.closeSlideout()
    },
    decreaseQuantity(variantId) {
      if (this.selectedProductsArray.find(product => product.variantId === variantId)) {
        this.removeProductFromSelections(variantId)
      }
    },
    increaseQuantity(index) {
      if (!this.maximumProductsReached) {
        this.addProductToSelections(index)
      }
    },
    isActiveProduct(variantId) {
      if (this.isCollectionBundle) {
        return this.collection.selectedProducts[this.activeCollectionIndex].variants[0].id === variantId
      } else {
        return !!this.collection.selectedProducts.find(selectedProduct => selectedProduct.variants[0].id === variantId)
      }
    },
    returnItemPrice(product, get = 'price') {
      const discount = this.collection.discount * 100
      const firstProductPrice = this.collection.products[0].price - discount
      const priceOfProduct = product.price - discount
      const difference = priceOfProduct - firstProductPrice

      if (get === 'difference') {
        return difference
      }

      if (difference > 0) {
        return `+ ${productPrice(difference)}`
      }
    }
  }
}
</script>
